import { Modal } from "antd";
import { JsonReportView } from "api/generated";
import { useMemo } from "react";

interface JsonReportDifferencesTableProps {
  onCancel: () => void;
  open: boolean;
  record: JsonReportView;
}

interface TableComponentProps {
  title: string;
  data: {
    column1: string;
    column2: string;
    column3: string;
    column4: string;
    values: (string | number)[];
  };
}

const TableComponent: React.FC<TableComponentProps> = ({ title, data }) => {
  return (
    <div
      style={{
        marginBottom: "1rem",
        border: "1px solid #e0e0e0",
        borderRadius: "0.5rem",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        padding: "1rem",
      }}
    >
      <h2
        style={{
          fontSize: "1.125rem",
          fontWeight: "600",
          marginBottom: "0.5rem",
        }}
      >
        {title}
      </h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          border: "1px solid #e0e0e0",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f7fafc" }}>
            <th style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.column1}
            </th>
            <th style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.column2}
            </th>
            <th style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.column3}
            </th>
            <th style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.column4}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.values[0]}
            </td>
            <td style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.values[1]}
            </td>
            <td style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.values[2]}
            </td>
            <td style={{ border: "1px solid #e0e0e0", padding: "0.5rem" }}>
              {data.values[3]}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

function JsonReportDifferencesTable({
  onCancel,
  open,
  record,
}: JsonReportDifferencesTableProps) {
  const DEFAULT_VALUE = 0;

  const dataA = useMemo(() => {
    const {
      lastMeasurement = DEFAULT_VALUE,
      calculatedVolume = DEFAULT_VALUE,
      differenceInventory = DEFAULT_VALUE,
      differenceInventoryPercentage = DEFAULT_VALUE,
    } = record;

    return {
      column1: "Volumen final lógico (L)",
      column2: "Volumen final físico (L)",
      column3: "Diferencia (L)",
      column4: "Diferencia (%)",
      values: [
        calculatedVolume,
        lastMeasurement,
        differenceInventory,
        `${differenceInventoryPercentage}%` || "0%",
      ],
    };
  }, [record]);

  const dataB = useMemo(() => {
    const {
      volumeSales = DEFAULT_VALUE,
      volumeSalesCfdis = DEFAULT_VALUE,
      salesDifferenceVolume = DEFAULT_VALUE,
      salesDifferencePercentage = DEFAULT_VALUE,
    } = record;
    return {
      column1: "Entregas (L)",
      column2: "CFDI- Entregas (L)",
      column3: "Diferencia (L)",
      column4: "Diferencia (%)",
      values: [
        volumeSales,
        volumeSalesCfdis,
        salesDifferenceVolume,
        `${salesDifferencePercentage}%` || "0%",
      ],
    };
  }, [record]);

  const dataC = useMemo(() => {
    const {
      volumeReceptions = DEFAULT_VALUE,
      volumeReceptionsCfdis = DEFAULT_VALUE,
      receptionDifferenceVolume = DEFAULT_VALUE,
      receptionDifferencePercentage = DEFAULT_VALUE,
    } = record;
    return {
      column1: "Recepciones (L)",
      column2: "CFDI-Recepciones (L)",
      column3: "Diferencia (L)",
      column4: "Diferencia (%)",
      values: [
        volumeReceptions,
        volumeReceptionsCfdis,
        receptionDifferenceVolume,
        `${receptionDifferencePercentage}%` || "0%",
      ],
    };
  }, [record]);

  return (
    <Modal
      title="Detalle de Diferencias"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered={true}
      width={1000}
    >
      <TableComponent title="A)" data={dataA} />
      <TableComponent title="B)" data={dataB} />
      <TableComponent title="C)" data={dataC} />
    </Modal>
  );
}

export default JsonReportDifferencesTable;
